module.exports = __webpack_public_path__ + "static/img/fullscreen-image_explore-your-options_fr.c3fd085.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/fullscreen-image_explore-your-options_fr.png
// module id = gMYB
// module chunks = 0